import { render, staticRenderFns } from "./Hotelequia.vue?vue&type=template&id=2a4d31b2&"
import script from "./Hotelequia.vue?vue&type=script&lang=js&"
export * from "./Hotelequia.vue?vue&type=script&lang=js&"
import style0 from "./Hotelequia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports